import { PERSONALIZATION_STATUS } from 'constants/personalizations';
import actions, { IP_COOKIES } from 'state/constants';
import initialState from 'state/initialState';

const fetchPersonalizationsRequestReducer = (state, action) => {
  const { selector } = action.payload;
  /*
    Attempt to load a DY experience and set isLoading flag for
    that specific experience right away so that we can update the UI
    while the experience loads. This is to prevent layout shift.
  */
  const newState = selector.names.reduce(
    (acc, name) => {
      acc[name] = { status: PERSONALIZATION_STATUS.LOADING };

      return acc;
    },
    { ...state }
  );

  return {
    ...newState,
  };
};

const fetchPersonalizationsSuccessReducer = (state, action) => {
  const { choices, selector, userIp } = action.payload;
  /*
      If DY responds with > 0 choices, then add each choice response
      to state and update status flag.
    */

  const stateWithChoices = choices.reduce(
    (acc, choice) => ({
      ...acc,
      [choice.name]: {
        ...acc[choice.name],
        ...choice,
      },
    }),
    { ...state }
  );

  return selector.names.reduce(
    (acc, name) => ({
      ...acc,
      [name]: {
        ...acc[name],
        status: PERSONALIZATION_STATUS.SUCCESS,
      },
    }),
    {
      ...stateWithChoices,
      cookies: [
        {
          name: IP_COOKIES.USER_IP,
          value: userIp,
        },
        ...action.payload.cookies,
      ],
    }
  );
};

const fetchPersonalizationsFailureReducer = (state, action) => {
  const { selector } = action.payload;
  /*
    DY http request has failed completely and update status flag.
  */
  const newState = selector.names.reduce(
    (acc, name) => {
      acc[name] = {
        status: PERSONALIZATION_STATUS.ERROR,
      };

      return acc;
    },
    { ...state }
  );

  return {
    ...newState,
  };
};

export const reducer = (state = initialState.personalizations, action) => {
  switch (action.type) {
    case actions.FETCH_PERSONALIZATIONS_REQUEST:
      return fetchPersonalizationsRequestReducer(state, action);
    case actions.FETCH_PERSONALIZATIONS_SUCCESS:
      return fetchPersonalizationsSuccessReducer(state, action);
    case actions.FETCH_PERSONALIZATIONS_FAILURE:
      return fetchPersonalizationsFailureReducer(state, action);
    default:
      return state;
  }
};

export default reducer;
